function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EritreaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4154",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "26",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "25.5",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4154)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V12H24V3H0Z",
      fill: "#43B764"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12V21H24V12H0Z",
      fill: "#B4D7F4"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3L24.75 12L0 21V3Z",
      fill: "#BE0027"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.27459 15.092L7.34246 15.4383H7.34248L7.2746 15.092C7.05119 14.6306 6.94376 14.1578 6.94376 13.6614C6.94376 13.5857 6.94565 13.5097 6.94946 13.4334L6.33469 10.2972C6.33469 10.2973 6.33468 10.2973 6.33468 10.2973L6.33468 10.2972C5.74072 11.4465 5.44374 12.5679 5.44374 13.6614C5.44374 13.7288 5.44356 13.7934 5.44338 13.8555C5.44087 14.728 5.43981 15.0979 5.97648 15.8497C6.1285 16.1464 6.31305 16.4364 6.53013 16.7198L6.53013 16.7198L6.53014 16.7198C6.53014 16.7198 6.53014 16.7198 6.53014 16.7198L6.53015 16.7198L7.45483 16.0115L6.83488 16.0258L7.13317 15.3464H7.13316L6.83486 16.0258L6.11923 16.0423C6.06785 15.9752 6.02037 15.9112 5.97648 15.8497C5.62133 15.1565 5.44376 14.4271 5.44376 13.6614C5.44376 12.5679 5.74073 11.4465 6.33468 10.2973L6.94944 13.4334C6.94564 13.5097 6.94374 13.5857 6.94374 13.6614C6.94374 14.1578 7.05118 14.6306 7.27459 15.092ZM6.83488 16.0258L6.83486 16.0258L6.53013 16.7198C6.53014 16.7198 6.53014 16.7198 6.53014 16.7198L6.53015 16.7198L6.83488 16.0258Z",
      fill: "#F3E294"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 12.375C1.5 15.0674 3.68261 17.25 6.375 17.25C9.06739 17.25 11.25 15.0674 11.25 12.375C11.25 9.68261 9.06739 7.5 6.375 7.5C3.68261 7.5 1.5 9.68261 1.5 12.375ZM9.75 12.375C9.75 14.239 8.23896 15.75 6.375 15.75C4.51104 15.75 3 14.239 3 12.375C3 10.511 4.51104 9 6.375 9C8.23896 9 9.75 10.511 9.75 12.375Z",
      fill: "#F3E294"
    })]
  })]
}));
//# sourceMappingURL=Eritrea.js.map